<template>
  <g>
    <text
      v-for="(label, index) in labels"
      :key="index"
      :transform="label.position"
      :font-size="getLabelFontSize(label)"
      text-anchor="middle"
    >
      {{ label.text }}
    </text>
  </g>
</template>

<script>
import { isEmpty } from 'ramda';
import { measureNoWrappedText } from '@shared/utils/measureText';
import { MAX_LABEL_SCALE, MIN_LABEL_SCALE } from './mapLabel.constants';

export default {
  props: {
    featureCollection: Object,
    chartData: Object,
    labelFontSize: Function,
    path: Function,
  },
  computed: {
    labels() {
      return this.featureCollection.features.reduce((list, item) => {
        const [x = 0, y = 0] = this.path.centroid(item);
        const text = item.properties.name.split('|')[0];

        if (isNaN(x) || isNaN(y) || isEmpty(text)) {
          return list;
        }

        const bounds = this.path.bounds(item);
        const y0 = bounds[0][1];
        const y1 = bounds[1][1];
        const width = y1 - y0;
        const { width: textWidth } = measureNoWrappedText(text, {
          fontSize: this.labelFontSize,
        });

        const scale = width / textWidth;
        const textScale = Math.max(MIN_LABEL_SCALE, Math.min(scale, MAX_LABEL_SCALE));

        list.push({
          text,
          position: `translate(${x}, ${y}) scale(${textScale})`,
        });

        return list;
      }, []);
    },
  },
  methods: {
    getLabelFontSize(label) {
      return this.labelFontSize(label, this);
    },
  },
};
</script>
